import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { StyledModal, ModalSubHeader } from './styled';
import { StyledModalHeaderIcon } from '../../shared'
import '../../styles/app.css'

const DynamicInvalidEntryModal = ({ date,  closePopUp, errorMessage }) => {
  const [isOpen, setIsOpen] = useState(true);
  const entryErrorDate = `${(date.toLocaleString('en-us', { month: 'long' }))}-${date.getDate()}-${date.getFullYear()}`;

  const toggle = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
    setTimeout(() => { closePopUp(); }, 300);
  };

  return (
    <StyledModal isOpen={isOpen} centered>
      <ModalHeader toggle={toggle}>
        <StyledModalHeaderIcon icon="exclamation-triangle" style={{ color: '#db011c' }} />Time entry not saved
      </ModalHeader>
      <ModalBody>     
        <Fragment>
          <ModalSubHeader>
            Please adjust your entry for <strong>{`${entryErrorDate}:`}</strong>
          </ModalSubHeader>
          <ul>
            <li>{errorMessage}</li>
          </ul>
        </Fragment>
      </ModalBody>
      <ModalFooter>
        <Button className="primary-antd-button" onClick={toggle}>Resubmit Time</Button>
      </ModalFooter>
    </StyledModal>
  );
};

DynamicInvalidEntryModal.propTypes = {
  closePopUp: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  errorMessage: PropTypes.string.isRequired
};

export default DynamicInvalidEntryModal;
